import { PixelRatioImage, type PixelRatioImageProps } from "@/components/common/pixel-ratio-image";
import ImageRule1 from "@/assets/custom-digital-human-rule/image_rule_3.webp";
import ImageRule2 from "@/assets/custom-digital-human-rule/image_rule_3@2x.webp";
import ImageRule3 from "@/assets/custom-digital-human-rule/image_rule_3@3x.webp";

export const ImageRule3Image = (props: Omit<PixelRatioImageProps, "images">) => {
  return (
    <PixelRatioImage
      images={[ImageRule3]}
      {...props}
    />
  );
};

ImageRule3Image.displayName = 'ImageRule3Image';
